// Feedback card layouts: avatar-left or avatar-right
export const LAYOUT_CONFIG = {
  'avatar-left': {
    profileSize: 300,
    profileBorderWidth: 10,
    profileDirection: 'left' as const,
    quotationPosition: 'bottom-right' as const,
    quotationSize: 'default' as const,
    contentAlign: 'left' as const,
  },
  'avatar-right': {
    profileSize: 300,
    profileBorderWidth: 10,
    profileDirection: 'right' as const,
    quotationPosition: 'left' as const,
    quotationSize: 'large' as const,
    contentAlign: 'right' as const,
  },
};

export const TIMING = {
  PROFILE_IMAGE: { startFrame: 15, distance: 100 },
  NAME: { startFrame: 25, stagger: 12 },
  QUOTE: { startFrame: 50, charsPerFrame: 1.5 },
  QUOTATION_MARKS: { startFrame: 40 },
  TRANSITION_DURATION: 20,
};

export const HOLD_DURATION_AFTER_COMPLETE = 30; // Hold duration after content completes (1 second at 30fps);
export const MIN_FEEDBACK_DURATION = 90; // Minimum feedback card duration (3 seconds at 30fps);
export const PROJECT_CODE_DELAY_FRAMES = 15; // Delay before showing project name after quote finishes (0.5 seconds at 30fps);
export const MAX_DISPLAY_FEEDBACKS = 3;
